export default __webpack_public_path__ + "static/media/up.fec45cba.png";